// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"3cb3815c","52":"19cfef68","258":"e0e4c740","422":"4a97c038","442":"eababf2e","645":"d2690d53","934":"1a0385fb","987":"a6d91715"}[chunkId] + ".chunk.js";
};